var scrollWidth = 14;
var CHECKBOX_WRAPPER_CLASS = 'rentpingCheckboxWrapper';

function wrapCheckbox(element) {
    var parentEl = element.parentNode,
        isWrapped = parentEl.classList.contains(CHECKBOX_WRAPPER_CLASS);

    if (!isWrapped) {
        //According to https://developer.mozilla.org/en-US/docs/Web/API/Document/createDocumentFragment this will use memory instead of causing a bunch of html reflows.
        var fragment = document.createDocumentFragment(),
            checkboxWrapper = document.createElement('div'),
            fakeCheckbox = document.createElement('div'),
            checkboxEls = Array.from(parentEl.childNodes);

        fakeCheckbox.classList.add('fakeCheckbox');
        fakeCheckbox.classList.add('border-primary');
        checkboxWrapper.classList.add(CHECKBOX_WRAPPER_CLASS);
        if (element.classList.contains('top-align-label')) {
            checkboxWrapper.classList.add('top-align-label');
        }

        fragment.appendChild(checkboxWrapper);
        fakeCheckbox.innerHTML =
            '<svg class="checkmarkSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.04 7.53" aria-label="checkbox" focusable="false"><path class="checkmarkPath" d="M2.51,6.81l.72.72L10,.72,9.32,0ZM0,4.3,2.51,6.81l.72-.72L.72,3.59Z"/></svg>';

        // fakeCheckbox must be the real checkbox's immediate next sibling so that the fake checkbox's styles are updated according to the real checkbox's state.
        checkboxEls.splice(checkboxEls.indexOf(element) + 1, 0, fakeCheckbox);
        wrapElements(checkboxEls, checkboxWrapper);
        wrapElements([checkboxWrapper], parentEl);

        var input = checkboxWrapper.querySelector('input[type="checkbox"]');

        fakeCheckbox.addEventListener('click', function () {
            input.click();
        });
    }
}

function wrapCheckboxes(parentElement) {
    var checkboxes = parentElement.querySelectorAll('input[type="checkbox"]');
    Array.prototype.forEach.call(checkboxes, wrapCheckbox);
}

function sortByUserChoice() {
    if (localStorage.lsBedType) filterBed(localStorage.lsBedType, localStorage.lsOtherBedTypesList);
}

function filterBed(bedType, otherBedTypesList) {
    localStorage.lsBedType = bedType;
    localStorage.lsOtherBedTypesList = otherBedTypesList;
    var otherBedTypes = otherBedTypesList.split(',');
    if (bedType == 'all') {
        for (var i = 0; i < otherBedTypes.length; i++) {
            $('#bed_' + otherBedTypes[i] + '_tab').removeClass('currentTab');
            $('.floorplanBed_' + otherBedTypes[i]).fadeIn();
        }
    } else {
        for (var i = 0; i < otherBedTypes.length; i++) {
            $('#bed_' + otherBedTypes[i] + '_tab').removeClass('currentTab');
            $('.floorplanBed_' + otherBedTypes[i]).hide(0);
        }
        $('.floorplanBed_' + bedType).fadeIn();
        if (bedType == 4) {
            for (var i = parseInt(bedType) + 1; i < 10; i++) {
                $('.floorplanBed_' + i).fadeIn();
            }
        }
    }
    $('#bed_' + bedType + '_tab').addClass('currentTab');
}

function isElementInView(targetElement, topPadding) {
    var elementBoundingTop = targetElement.getBoundingClientRect().top;

    if (topPadding) {
        elementBoundingTop -= topPadding;
    }

    return elementBoundingTop >= 0;
}

function getOuterWidthWithMargin(element) {
    if (!element) return 0;
    const style = window.getComputedStyle(element);
    const marginLeft = parseInt(style.marginLeft, 10) || 0;
    const marginRight = parseInt(style.marginRight, 10) || 0;

    return element.offsetWidth + marginLeft + marginRight;
}

function trimHeader() {
    const header = document.querySelector('header');
    if (header && header.classList.contains('nav-v2')) {
        return;
    }
    document.querySelectorAll('.navigationLinks a').forEach((a) => (a.style.display = ''));
    const moreHeader = document.getElementById('moreHeader');
    const moreWidth = getOuterWidthWithMargin(moreHeader);
    moreHeader.style.display = 'none';
    const headerWrapper = document.querySelector('.headerWrapper');
    const headerWrapperComputedStyle = window.getComputedStyle(headerWrapper, null);
    const headerPadding =
        parseFloat(headerWrapperComputedStyle.paddingLeft) + parseFloat(headerWrapperComputedStyle.paddingRight);
    const headerWidth = parseFloat(headerWrapperComputedStyle.width);
    const headerWidthPlusPadding = headerWidth + headerPadding;
    const logoWidth = getOuterWidthWithMargin(document.querySelector('.header-logos-wrapper'));
    const linksWidth = getOuterWidthWithMargin(document.querySelector('.headerLinks'));
    const phoneWidth = getOuterWidthWithMargin(document.querySelector('.headerWrapper .navigation-cta'));

    if (headerWidth < logoWidth + linksWidth + phoneWidth) {
        let availableWidth = headerWidth - logoWidth - phoneWidth - moreWidth;

        document
            .querySelectorAll('.navigationLinks > .floorplan-list-container, .navigationLinks > a:not(#moreHeader)')
            .forEach(function (element) {
                availableWidth -= getOuterWidthWithMargin(element);
                if (availableWidth < 0 && !element.classList.contains('floorplan-list-container')) {
                    //Don't hide the floorplan list
                    element.style.display = 'none';
                }
            });
        if (availableWidth < 0) {
            document.querySelector('header').classList.add('hasMore');
            moreHeader.style.display = '';
            const extraLinks = document.getElementById('extraLinks');
            extraLinks.innerHTML = '';
            document.querySelectorAll('.navigationLinks > a[style*="display: none"]').forEach(function (element) {
                const copiedLink = element.cloneNode(true);
                copiedLink.style.display = 'block';
                copiedLink.classList.add('header-dropdown-link');
                copiedLink.classList.remove('header-link');
                const li = document.createElement('li');
                li.appendChild(copiedLink);
                extraLinks.appendChild(li);
            });
            const newHeight = document.getElementById('extraLinks').scrollHeight + 'px';
            const moreHeaderRect = moreHeader.getBoundingClientRect();
            extraLinks.style.maxHeight = newHeight;
            let extraLinksWidth = extraLinks.offsetWidth;
            if (extraLinksWidth == 0) {
                extraLinks.style.display = '';
                extraLinksWidth = extraLinks.offsetWidth;
                extraLinks.style.display = 'none';
            }
            extraLinksWidth--; //subtract 1px for the box shadow that looks like a border
            extraLinks.style.left = moreHeaderRect.left + moreHeaderRect.width - extraLinksWidth + 'px';
            extraLinks.style.top = moreHeader.offsetTop + moreHeaderRect.height + 'px';
        } else {
            document.querySelector('header').classList.remove('hasMore');
            document.getElementById('extraLinks').style.display = 'none';
            document.getElementById('extraLinks').classList.remove('show');
        }
    } else {
        document.querySelector('header').classList.remove('hasMore');
        document.getElementById('extraLinks').style.display = 'none';
        document.getElementById('extraLinks').classList.remove('show');
    }

    // See if we're pushing the phone number offscreen. Account for left padding of header. Re-check links width as that may have changed with the "more" dropdown.
    if (
        headerWidthPlusPadding -
            headerPadding / 2 -
            logoWidth -
            getOuterWidthWithMargin(document.querySelector('.headerLinks')) -
            phoneWidth <
            0 ||
        window.innerWidth < 768
    ) {
        document.querySelector('header').classList.add('force-opaque');
    } else {
        document.querySelector('header').classList.remove('force-opaque');
    }
}

function syncVerticalLogoSize() {
    // Reads --nav-v2-logo-vertical-max-height and --nav-v2-vertical-logo-padding from header.less CSS vars.
    const header = document.getElementsByTagName('header')[0];
    if (!header || !header.classList.contains('nav-v2')) {
        return;
    }
    const wrapper = document.querySelector('.nav-v2-logo-wrapper.nav-v2-has-vertical-logo');
    if (!wrapper) {
        return;
    }
    const verticalLogoContainer = document.querySelector('.nav-v2-vertical-white-logo');
    const isTag = !!(verticalLogoContainer && verticalLogoContainer.classList.contains('nav-v2-logo-tag'));
    const wrapperStyles = window.getComputedStyle(wrapper);
    const maxLogoHeight = parseFloat(wrapperStyles.getPropertyValue('--nav-v2-logo-vertical-max-height')) || 180;
    const tagPadding = parseFloat(wrapperStyles.getPropertyValue('--nav-v2-vertical-logo-padding')) || 12;
    const verticalOffset = isTag ? tagPadding * 2 : 24;
    const availableHeight = Math.max(0, wrapper.offsetHeight - verticalOffset);
    const height = Math.min(maxLogoHeight, availableHeight);
    wrapper.style.setProperty('--nav-v2-vertical-logo-height', `${height}px`);
}

function runVerticalLogoSizeAnimation(durationMs) {
    if (stickyHeader.navV2SizeAnimationFrame) {
        cancelAnimationFrame(stickyHeader.navV2SizeAnimationFrame);
        stickyHeader.navV2SizeAnimationFrame = null;
    }
    const start = performance.now();
    function tick(now) {
        syncVerticalLogoSize();
        if (now - start < durationMs) {
            stickyHeader.navV2SizeAnimationFrame = requestAnimationFrame(tick);
        } else {
            stickyHeader.navV2SizeAnimationFrame = null;
            syncVerticalLogoSize();
        }
    }
    stickyHeader.navV2SizeAnimationFrame = requestAnimationFrame(tick);
}

function stickyHeader() {
    const isHighContrast = root.classList.contains('high-contrast');
    const NAV_V2_LAYOUT_TRANSITION_MS = 250;
    if (typeof bypassStickyHeader === 'undefined' || !bypassStickyHeader) {
        let cutoff = 0;

        // Store DOM elements in constants
        const bannerContent = document.getElementsByClassName('banner-content')[0];
        const header = document.getElementsByTagName('header')[0];
        const specialLinksWrapper = document.getElementsByClassName('specialLinksWrapper')[0];
        const isNavV2 = header && header.classList.contains('nav-v2');
        const verticalWhiteLogoLink = isNavV2
            ? document.querySelector('.nav-v2-vertical-white-logo a.nav-v2-logo-link')
            : document.querySelector('.verticalWhiteLogoContainer a.logo');
        const whiteLogoLink = isNavV2
            ? document.querySelector('.nav-v2-horizontal-white-logo a.nav-v2-logo-link')
            : document.querySelector('.whiteLogoContainer a.logo');
        const standardLogoLink = isNavV2
            ? document.querySelector('.nav-v2-horizontal-color-logo a.nav-v2-logo-link')
            : document.querySelector('.standardLogoContainer a.logo');
        const navV2CtaBtn = isNavV2 ? document.querySelector('.nav-v2-primary-cta-btn') : null;
        const skipNavBanner = document.getElementsByClassName('skipNavBanner')[0];
        const mainNavigation = document.getElementById('mainNavigation');
        const body = document.body;

        const hasBanner = bannerContent && isVisible(bannerContent);
        if (hasBanner) {
            cutoff += bannerContent.offsetHeight;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const isScrolledDown = scrollTop > cutoff;
        const wasScrolledDown = header.classList.contains('fixed');

        if (navV2CtaBtn) {
            navV2CtaBtn.classList.add('no-transition');
        }

        if (isNavV2 && wasScrolledDown && !isScrolledDown) {
            header.classList.remove('fixed', 'nav-v2-scrolled', 'nav-v2-tag-crossfade');
            header.style.removeProperty('--nav-v2-tag-crossfade-offset');
        }

        if (isNavV2) {
            // Nav v2 scroll uses three independent header classes:
            // - nav-v2-layout-compact: logo wrapper height/alignment (scroll down, or high contrast at page top)
            // - nav-v2-scrolled (+ fixed): visual state — overlay, logo crossfade, link/social colors
            // - nav-v2-hero-anchor: vertical logo top-hang position after scroll-up expansion finishes
            const useCompactLayout = isScrolledDown || isHighContrast;

            if (useCompactLayout) {
                if (stickyHeader.navV2HeroAnchorTimeout) {
                    clearTimeout(stickyHeader.navV2HeroAnchorTimeout);
                    stickyHeader.navV2HeroAnchorTimeout = null;
                }
                if (stickyHeader.navV2SizeAnimationFrame) {
                    cancelAnimationFrame(stickyHeader.navV2SizeAnimationFrame);
                    stickyHeader.navV2SizeAnimationFrame = null;
                }
                header.classList.remove('nav-v2-hero-anchor');
                header.classList.add('nav-v2-layout-compact');
            } else {
                header.classList.remove('nav-v2-hero-anchor');
                if (header.classList.contains('nav-v2-layout-compact')) {
                    if (stickyHeader.navV2HeroAnchorTimeout) {
                        clearTimeout(stickyHeader.navV2HeroAnchorTimeout);
                        stickyHeader.navV2HeroAnchorTimeout = null;
                    }
                    header.classList.remove('nav-v2-layout-compact');
                    const headerFiller = document.querySelector('.headerFiller');
                    runVerticalLogoSizeAnimation(NAV_V2_LAYOUT_TRANSITION_MS);
                    if (headerFiller) {
                        headerFiller.style.minHeight = `${header.offsetHeight}px`;
                    }
                    stickyHeader.navV2HeroAnchorTimeout = window.setTimeout(function () {
                        stickyHeader.navV2HeroAnchorTimeout = null;
                        header.classList.add('nav-v2-hero-anchor');
                        syncVerticalLogoSize();
                        if (headerFiller) {
                            headerFiller.style.minHeight = `${header.offsetHeight}px`;
                        }
                    }, NAV_V2_LAYOUT_TRANSITION_MS);
                } else if (!header.classList.contains('nav-v2-layout-compact')) {
                    header.classList.add('nav-v2-hero-anchor');
                }
            }
            syncVerticalLogoSize();
        }

        if (isScrolledDown) {
            // if is scrolled down
            header.classList.add('fixed');
            if (header.classList.contains('nav-v2')) {
                header.classList.add('nav-v2-scrolled');
            }

            if (isNavV2 && !wasScrolledDown) {
                const horizontalTag = document.querySelector('.nav-v2-horizontal-white-logo.nav-v2-logo-tag');
                if (horizontalTag) {
                    const logoWrapper = document.querySelector('.nav-v2-logo-wrapper');
                    const headerRow = document.querySelector('.nav-v2-header-wrapper');
                    if (logoWrapper && headerRow) {
                        const wrapperTopOffset =
                            logoWrapper.getBoundingClientRect().top - headerRow.getBoundingClientRect().top;
                        header.style.setProperty('--nav-v2-tag-crossfade-offset', `${wrapperTopOffset}px`);
                    }
                    header.classList.add('nav-v2-tag-crossfade');
                    if (stickyHeader.navV2TagCrossfadeTimeout) {
                        clearTimeout(stickyHeader.navV2TagCrossfadeTimeout);
                    }
                    stickyHeader.navV2TagCrossfadeTimeout = window.setTimeout(function () {
                        stickyHeader.navV2TagCrossfadeTimeout = null;
                        header.classList.remove('nav-v2-tag-crossfade');
                        header.style.removeProperty('--nav-v2-tag-crossfade-offset');
                    }, NAV_V2_LAYOUT_TRANSITION_MS);
                }
            }

            if (header.classList.contains('transparent') && (!isNavV2 || !header.classList.contains('home'))) {
                header.classList.remove('transparent');
            }

            if (specialLinksWrapper && specialLinksWrapper.classList.contains('home')) {
                specialLinksWrapper.classList.remove('transparent');
            }

            if (hasBanner) {
                body.classList.remove('banner');
            }

            if (verticalWhiteLogoLink) {
                verticalWhiteLogoLink.setAttribute('tabindex', '-1');
            }

            if (whiteLogoLink) {
                whiteLogoLink.setAttribute('tabindex', '-1');
            }

            if (standardLogoLink) {
                standardLogoLink.setAttribute('tabindex', '0');
            }

            if (skipNavBanner) {
                skipNavBanner.classList.add('fixed');
            }

            if (skipNavBanner && skipNavBanner.contains(document.activeElement)) {
                if (mainNavigation) {
                    mainNavigation.classList.add('skipNavBannerShown');
                }
                if (specialLinksWrapper) {
                    specialLinksWrapper.classList.add('skipNavBannerShown');
                }
            }
        } else {
            // if is scrolled up
            if (stickyHeader.navV2TagCrossfadeTimeout) {
                clearTimeout(stickyHeader.navV2TagCrossfadeTimeout);
                stickyHeader.navV2TagCrossfadeTimeout = null;
            }
            header.classList.remove('nav-v2-tag-crossfade');
            header.style.removeProperty('--nav-v2-tag-crossfade-offset');
            if (header.classList.contains('nav-v2')) {
                header.classList.remove('nav-v2-scrolled');
            }
            if (!isHighContrast || hasBanner) {
                header.classList.remove('fixed');
            }

            if (header.classList.contains('home')) {
                header.classList.add('transparent');
            }

            if (specialLinksWrapper && specialLinksWrapper.classList.contains('home')) {
                specialLinksWrapper.classList.add('transparent');
            }

            if (hasBanner) {
                body.classList.add('banner');
            }

            if (isNavV2) {
                const showTransparentHeroLogos =
                    header.classList.contains('transparent') &&
                    !header.classList.contains('force-opaque') &&
                    !isHighContrast;
                if (showTransparentHeroLogos) {
                    if (verticalWhiteLogoLink) {
                        verticalWhiteLogoLink.setAttribute('tabindex', '0');
                        if (standardLogoLink) {
                            standardLogoLink.setAttribute('tabindex', '-1');
                        }
                    } else if (whiteLogoLink) {
                        whiteLogoLink.setAttribute('tabindex', '0');
                        if (standardLogoLink) {
                            standardLogoLink.setAttribute('tabindex', '-1');
                        }
                    } else if (standardLogoLink) {
                        standardLogoLink.setAttribute('tabindex', '0');
                    }
                } else {
                    if (verticalWhiteLogoLink) {
                        verticalWhiteLogoLink.setAttribute('tabindex', '-1');
                    }
                    if (whiteLogoLink) {
                        whiteLogoLink.setAttribute('tabindex', '-1');
                    }
                    if (standardLogoLink) {
                        standardLogoLink.setAttribute('tabindex', '0');
                    }
                }
            } else if (verticalWhiteLogoLink) {
                verticalWhiteLogoLink.setAttribute('tabindex', '0');
                if (standardLogoLink) {
                    standardLogoLink.setAttribute('tabindex', '-1');
                }
            } else if (whiteLogoLink) {
                whiteLogoLink.setAttribute('tabindex', '0');
                if (standardLogoLink) {
                    standardLogoLink.setAttribute('tabindex', '-1');
                }
            } else if (standardLogoLink) {
                standardLogoLink.setAttribute('tabindex', '0');
            }

            if (skipNavBanner) {
                skipNavBanner.classList.remove('fixed');
            }

            if (mainNavigation) {
                mainNavigation.classList.remove('skipNavBannerShown');
            }

            if (hasBanner) {
                if (specialLinksWrapper) {
                    specialLinksWrapper.classList.remove('skipNavBannerShown');
                }
            }
        }

        if (navV2CtaBtn) {
            queueMicrotask(function () {
                navV2CtaBtn.classList.remove('no-transition');
            });
        }

        syncTabletFixedHeaderScroll();
    } else {
        const specialLinksWrapper = document.getElementsByClassName('specialLinksWrapper')[0];
        if (specialLinksWrapper) {
            specialLinksWrapper.classList.remove('fixed');
        }
    }
}

function isTabletForcedLayout() {
    return window.matchMedia('(max-width: 767px)').matches;
}

function syncTabletFixedHeaderScroll() {
    const scrollX = window.scrollX || document.documentElement.scrollLeft || 0;

    if (isTabletForcedLayout()) {
        document.documentElement.style.setProperty('--tablet-scroll-x', `${scrollX}px`);
    } else {
        document.documentElement.style.removeProperty('--tablet-scroll-x');
    }
}

function stickyFooter() {
    if (typeof bypassStickyFooter === 'undefined' || !bypassStickyFooter) {
        var footer = $('footer');
        footer.css({ position: 'relative' });
        var gap = $(document).outerHeight() - footer.outerHeight() - footer.offset().top;
        if ($(document).outerHeight() <= $(window).height() && gap > 0) {
            footer.css({ position: 'absolute' });
        }
    }
}

function getScrollDuration(time, idealPixels, actualPixels) {
    var timePerPixel = time / idealPixels;
    return Math.floor(timePerPixel * actualPixels);
}

function scrollIntoView($target, time, idealPixels, opts, topBuffer) {
    var offsetTop = $target.offset().top,
        options = opts != null ? opts : {},
        $topBar = $('header');

    if ($topBar.length) {
        offsetTop -= $topBar.outerHeight();

        if (!!topBuffer) {
            offsetTop -= topBuffer;
        }
    }

    if (time != null && idealPixels != null) {
        options.duration = getScrollDuration(time, idealPixels, offsetTop);
    }

    $('html,body').animate(
        {
            scrollTop: offsetTop,
        },
        options,
    );
}

document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
        $('.scrollToButton').on('click', function (event) {
            var $this = $(this),
                $target = $($this.data('target'));

            event.preventDefault();
            scrollIntoView($target, 1000, 1000);
        });
    });
    wrapCheckboxes(document);
    initRvMultiselect(document);
});

function canUseCssVariables() {
    return window.CSS && window.CSS.supports && window.CSS.supports('--test-var', 0);
}

function getCoverHeight() {
    return document.documentElement.clientHeight;
}

function getCoverWidth() {
    return document.documentElement.clientWidth;
}

function setCoverSize(content, useVars) {
    if (useVars) {
        content.style.setProperty('--coverWidth', getCoverWidth() + 'px');
        content.style.setProperty('--coverHeight', getCoverHeight() + 'px');
    } else {
        content.style.width = getCoverWidth() + 'px';
        content.style.height = getCoverHeight() + 'px';
    }
}

function initCoverHero() {
    var heroContent = document.querySelector('.heroContent'),
        useVars = canUseCssVariables();

    if (!!heroContent) {
        setCoverSize(heroContent, useVars);

        if (!useVars) {
            //This is for browsers that don't support css vars like ie11
            var sliderItems = Array.from(heroContent.querySelectorAll('.sliderItem .sliderItemA'));

            Array.prototype.forEach.call(sliderItems, function (el) {
                setCoverSize(el, false);
            });

            window.addEventListener('resize', function () {
                setCoverSize(heroContent, false);
                Array.prototype.forEach.call(sliderItems, function (el) {
                    setCoverSize(el, false);
                });
            });
        } else {
            window.addEventListener('resize', function () {
                setCoverSize(heroContent, true);
            });
        }
    }
}

initCoverHero();

function resizeBackgroundVideo() {
    var video = document.querySelector('.background-video video');
    if (video && (window.getComputedStyle(video).display === 'none' || video.classList.contains('custom'))) {
        //One of these needs to be auto depending on the ratio.
        var ratio = document.documentElement.clientWidth / document.documentElement.clientHeight;
        if (ratio > 1.5) {
            var idealHeight = document.documentElement.clientWidth / 1.5;
            video.style.width = document.documentElement.clientWidth + 'px';
            video.style.height = 'auto';
            video.style.marginTop = (document.documentElement.clientHeight - idealHeight) / 2 + 'px';
            video.style.marginLeft = '';
        } else {
            var idealWidth = document.documentElement.clientHeight * 1.5;
            video.style.width = 'auto';
            video.style.height = document.documentElement.clientHeight + 'px';
            video.style.marginTop = '';
            video.style.marginLeft = (document.documentElement.clientWidth - idealWidth) / 2 + 'px';
        }
        if (!video.classList.contains('custom')) {
            video.style.display = 'block';
            video.classList.add('custom');
        }
    }
}

// add/remove styling to push down navigation menu to make room for the skip main navigation banner
function toggleSkipNavBanner(focus) {
    if ($('.skipNavBanner').hasClass('fixed')) {
        if (focus === 'focusIn') {
            $('#mainNavigation').addClass('skipNavBannerShown');
            $('.specialLinksWrapper').addClass('skipNavBannerShown');
        } else if (focus === 'focusOut') {
            $('#mainNavigation').removeClass('skipNavBannerShown');
            $('.specialLinksWrapper').removeClass('skipNavBannerShown');
        }
    } else if (!$('.banner-content:visible').length > 0) {
        if (focus === 'focusIn') {
            $('.specialLinksWrapper').addClass('skipNavBannerShown');
        } else if (focus === 'focusOut') {
            $('.specialLinksWrapper').removeClass('skipNavBannerShown');
        }
    }
}

function skipToContent() {
    if ($('#player-cover-video').length > 0) {
        // if a wistia video background is used, we need to skip to the first tab-stop in the video player
        $('#player-cover-video').find(':tabbable').first().focus();
    } else if ($('.homeTopRight').find('a').length > 0) {
        // focus on the first anchor tag in a homepage special if it exists
        $('.homeTopRight').find('a').first().focus();
    } else {
        // focus on the first tabbable element inside of the element with class skipNavContent
        $('.skipNavContent').find(':tabbable').first().focus();
    }
}
